// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.full-width {
  width: 100%;
}
.full-height {
  height: 100%;
}
.flex-h {
  display: flex;
  flex-direction: row;
}
.flex-v {
  display: flex;
  flex-direction: column;
}
.flex-grow {
  flex-grow: 1;
}
.nowrap {
  white-space: nowrap;
}
.text-right {
  text-align: right;
}
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
h1 {
  font-size: 36px;
}
h3,
h1 {
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  margin-top: 20px;
  margin-bottom: 10px;
}
button,
input,
select,
textarea {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}
.row {
  margin-right: -15px;
  margin-left: -15px;
}
.pull-left {
  float: left !important;
}
.pull-right {
  float: right !important;
}
.fade {
  opacity: 0;
  -webkit-transition: opacity 0.15s linear;
  -o-transition: opacity 0.15s linear;
  transition: opacity 0.15s linear;
}
.fade.in {
  opacity: 1;
}
a {
  color: #8784ee;
  text-decoration: none;
}
:root {
  --series-count-background-color: #3c4468;
  --active-color: #8784ee;
}
.thumbnail.active .alt-image-text {
  border-color: var(--active-color);
  box-shadow: none;
  transition: var(--sidebar-transition);
}
.thumbnail {
  cursor: pointer;
  display: table;
  margin: 0 auto;
  min-width: 90%;
  padding-bottom: 1.5rem;
}
.thumbnail .alt-image-text {
  align-items: center;
  justify-content: center;
  background-color: var(--primary-background-color);
  box-shadow: inset 0 0 0 1px var(--ui-border-color-dark);
  border: 2px solid transparent;
  border-radius: 12px;
  min-height: 135px;
  max-height: 250px;
  margin: 0 auto;
  padding: 5px;
  position: relative;
  transition: var(--sidebar-transition);
  width: 217px;
  display: flex;
}
.thumbnail .alt-image-text h1 {
  text-align: center;
  color: var(--text-primary-color);
  max-width: 200px;
  max-height: 250px;
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
}
.thumbnail .series-details {
  display: flex;
  flex-direction: column;
  color: var(--text-primary-color);
  font-size: 14px;
  line-height: 1.3em;
  margin-top: 5px;
  margin-left: 1rem;
  margin-right: 0.5rem;
  max-width: 217px;
  position: relative;
  word-wrap: break-word;
}
.thumbnail .series-details .series-description {
  flex-grow: 1;
}
.thumbnail .series-details.info-only .series-description {
  display: none;
}
.thumbnail .series-information {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.thumbnail .series-information .item-frames .icon {
  height: 18px;
}
.thumbnail .series-information .item-series {
  display: flex;
}
.thumbnail .series-information .item-series.image-frames .icon {
  background-color: var(--series-count-background-color);
  margin-top: 6px;
  position: relative;
}
.thumbnail .series-information .item-series.image-frames .icon:after {
  content: '';
  background-color: var(--active-color);
  box-shadow: 1px 1px rgba(0,0,0,0.115);
  left: -4px;
  position: absolute;
  top: -4px;
}
.thumbnail .series-information .item-series.image-frames .icon,
.thumbnail .series-information .item-series.image-frames .icon:after {
  content: '';
  border: 0px solid var(--series-count-background-color);
  display: inline-block;
  height: 11px;
  width: 11px;
}
.thumbnail .series-information .warning {
  margin: auto 0;
  opacity: 1;
  color: #e29e4a;
}
.thumbnail .series-information .warning svg {
  width: 16px;
  height: 14px;
  pointer-events: inherit;
}
.thumbnail .series-information .value {
  color: var(--text-secondary-color);
  display: inline-block;
  font-size: 12px;
  margin-left: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: calc(100% - 15px);
  vertical-align: middle;
}
.thumbnail .series-information .icon {
  color: var(--active-color);
  display: inline-block;
  font-size: 10px;
  font-weight: 900;
  text-align: left;
  width: 15px;
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/components/common/global.styl","webpack://./../../ui/src/components/studyBrowser/Thumbnail.styl"],"names":[],"mappings":"AAAA;EACE,8BAAoB;EACpB,2BAAiB;EACjB,sBAAY;ACCd;ADCA;EACE,WAAO;ACCT;ADCA;EACE,YAAQ;ACCV;ADCA;EACE,aAAS;EACT,mBAAgB;ACClB;ADCA;EACE,aAAS;EACT,sBAAgB;ACClB;ADCA;EACE,YAAW;ACCb;ADCA;EACE,mBAAa;ACCf;ADCA;EACE,iBAAY;ACCd;ADCA;EACE,kBAAY;ACCd;ADCA;EACE,gBAAY;ACCd;ADCA;EACE,eAAW;ACCb;ADCA;;EACE,oBAAa;EACb,gBAAa;EACb,gBAAa;EACb,gBAAY;EACZ,mBAAe;ACEjB;ADAA;;;;EACE,oBAAa;EACb,kBAAW;EACX,oBAAa;ACKf;ADHA;EACE,mBAAc;EACd,kBAAa;ACKf;ADHA;EACE,sBAAO;ACKT;ADHA;EACE,uBAAO;ACKT;ADHA;EACE,UAAS;EACT,wCAAoB;EACpB,mCAAe;EACf,gCAAY;ACKd;ADHA;EACE,UAAS;ACKX;ADHA;EACE,cAAO;EACP,qBAAiB;ACKnB;AAzEA;EACE,wCAAiC;EACjC,uBAAgB;AA2ElB;AAvEE;EACE,iCAAc;EACd,gBAAY;EACZ,qCAAY;AAyEhB;AAvEA;EACE,eAAQ;EACR,cAAS;EACT,cAAQ;EACR,cAAW;EACX,sBAAgB;AAyElB;AAvEE;EACE,mBAAa;EACb,uBAAiB;EACjB,iDAAkB;EAClB,uDAAY;EACZ,6BAAQ;EACR,mBAAe;EACf,iBAAY;EACZ,iBAAY;EACZ,cAAQ;EACR,YAAS;EACT,kBAAU;EACV,qCAAY;EACZ,YAAO;EACP,aAAS;AAyEb;AAvEI;EACE,kBAAY;EACZ,gCAAO;EACP,gBAAW;EACX,iBAAY;EACZ,yBAAe;EACf,qBAAW;EACX,aAAS;AAyEf;AAvEE;EACE,aAAS;EACT,sBAAgB;EAChB,gCAAO;EACP,eAAW;EACX,kBAAa;EACb,eAAY;EACZ,iBAAa;EACb,oBAAc;EACd,gBAAW;EACX,kBAAU;EACV,qBAAW;AAyEf;AAvEI;EACE,YAAW;AAyEjB;AAvEI;EACE,aAAS;AAyEf;AAvEE;EACE,aAAS;EACT,mBAAgB;EAChB,8BAAiB;AAyErB;AAvEI;EACE,YAAQ;AAyEd;AAvEI;EACE,aAAS;AAyEf;AAvEI;EACI,sDAAkB;EAClB,eAAY;EACZ,kBAAU;AAyElB;AAvEQ;EACE,WAAS;EACT,qCAAkB;EAClB,qCAAY;EACZ,UAAM;EACN,kBAAU;EACV,SAAK;AAyEf;AAvEQ;;EAEE,WAAS;EACT,sDAAQ;EACR,qBAAS;EACT,YAAQ;EACR,WAAO;AAyEjB;AAvEI;EACE,cAAQ;EACR,UAAS;EACT,cAAO;AAyEb;AAvEM;EACE,WAAO;EACP,YAAQ;EACR,uBAAgB;AAyExB;AAtEI;EACE,kCAAO;EACP,qBAAS;EACT,eAAW;EACX,gBAAa;EACb,gBAAU;EACV,uBAAe;EACf,mBAAa;EACb,wBAAO;EACP,sBAAgB;AAwEtB;AAtEI;EACE,0BAAO;EACP,qBAAS;EACT,eAAW;EACX,gBAAa;EACb,gBAAY;EACZ,WAAO;AAwEb","sourcesContent":["*\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n\n.full-width\n  width: 100%\n\n.full-height\n  height: 100%\n\n.flex-h\n  display: flex\n  flex-direction: row\n\n.flex-v\n  display: flex\n  flex-direction: column\n\n.flex-grow\n  flex-grow: 1\n\n.nowrap\n  white-space: nowrap\n\n.text-right\n  text-align: right;\n\n.text-center\n  text-align: center;\n\n.text-left\n  text-align: left;\n\nh1\n  font-size: 36px;\n\nh3, h1\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  margin-top: 20px;\n  margin-bottom: 10px;\n\nbutton, input, select, textarea\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n\n.row\n  margin-right: -15px;\n  margin-left: -15px;\n\n.pull-left\n  float: left!important;\n\n.pull-right\n  float: right!important;\n\n.fade\n  opacity: 0;\n  -webkit-transition: opacity .15s linear;\n  -o-transition: opacity .15s linear;\n  transition: opacity .15s linear;\n\n.fade.in\n  opacity: 1;\n\na\n  color: #8784EE;\n  text-decoration: none;\n","@import '../common/global.styl'\n\n:root {\n  --series-count-background-color: #3C4468;\n  --active-color: #8784EE;\n}\n\n.thumbnail.active\n  .alt-image-text\n    border-color: var(--active-color);\n    box-shadow: none\n    transition: var(--sidebar-transition);\n\n.thumbnail\n  cursor: pointer\n  display: table\n  margin: 0 auto;\n  min-width: 90%;\n  padding-bottom: 1.5rem;\n\n  .alt-image-text\n    align-items: center;\n    justify-content: center;\n    background-color: var(--primary-background-color);\n    box-shadow: inset 0 0 0 1px var(--ui-border-color-dark);\n    border: 2px solid transparent;\n    border-radius: 12px;\n    min-height: 135px;\n    max-height: 250px;\n    margin: 0 auto;\n    padding: 5px;\n    position: relative;\n    transition: var(--sidebar-transition);\n    width: 217px;\n    display: flex;\n\n    h1\n      text-align: center\n      color: var(--text-primary-color);\n      max-width: 200px;\n      max-height: 250px;\n      overflow-wrap: break-word;\n      word-wrap: break-word;\n      hyphens: auto;\n\n  .series-details\n    display: flex;\n    flex-direction: column\n    color: var(--text-primary-color);\n    font-size: 14px\n    line-height: 1.3em\n    margin-top: 5px\n    margin-left: 1rem\n    margin-right: 0.5rem\n    max-width: 217px\n    position: relative\n    word-wrap: break-word\n\n    .series-description\n      flex-grow: 1\n\n    &.info-only .series-description\n      display: none\n\n  .series-information\n    display: flex\n    flex-direction: row\n    justify-content: space-between\n\n    .item-frames .icon\n      height: 18px\n\n    .item-series\n      display: flex\n\n    .item-series.image-frames .icon\n        background-color: var(--series-count-background-color);\n        margin-top: 6px\n        position: relative\n\n        &:after\n          content: ''\n          background-color: var(--active-color);\n          box-shadow: 1px 1px rgba(0, 0, 0, .115)\n          left: -4px\n          position: absolute\n          top: -4px\n\n        &\n        &:after\n          content: ''\n          border: 0px solid var(--series-count-background-color)\n          display: inline-block\n          height: 11px\n          width: 11px\n\n    .warning\n      margin: auto 0;\n      opacity: 1\n      color: #e29e4a;\n\n      svg\n        width: 16px;\n        height: 14px;\n        pointer-events: inherit;\n\n\n    .value\n      color: var(--text-secondary-color);\n      display: inline-block\n      font-size: 12px\n      margin-left: 4px\n      overflow: hidden\n      text-overflow: ellipsis\n      white-space: nowrap\n      width: calc(100% - 15px)\n      vertical-align: middle\n\n    .icon\n      color: var(--active-color);\n      display: inline-block\n      font-size: 10px\n      font-weight: 900\n      text-align: left\n      width: 15px\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
